import React, { useEffect } from "react"
import thunk from "redux-thunk"
// import thunkMiddleware from "redux-thunk"
import { createStore, applyMiddleware, compose } from "redux"
import { Provider } from "react-redux"
import allReducers from "./src/redux/reducers"
import Layout from "./src/components/layout/layout"
import SupportingDocument from "./src/components/supportingDocument"
import TagManager from "react-gtm-module"
import * as API from "./src/services/httpService"
import { navigate } from "gatsby"

const BaseApp = ({ element }) => {
  const middleware = [thunk]

  const store = createStore(
    allReducers,
    compose(
      applyMiddleware(...middleware)
      // ,
      // window.__REDUX_DEVTOOLS_EXTENSION__ &&
      //   window.__REDUX_DEVTOOLS_EXTENSION__()
    )
  )

  useEffect(() => {
    window.onbeforeunload = function() {
      return "Are you sure want to leave this page?"
    }
    // window.addEventListener("unload", async event => {
    //   return "Are you sure want to leave this page?"
    // })

    API.apiPostRequest("/Claim/GetGtmCodeValue", null, null)
      .then(values => {
        if (values.data) {
          const tagManagerArgs = {
            gtmId: values.data,
            dataLayerName: "eclaim",
          }
          TagManager.initialize(tagManagerArgs)
        }
      })
      .catch(error => {
        navigate("errorOccurred")
      })
  }, [])
  return (
    <Provider store={store}>
      <Layout>
        <SupportingDocument />
        {element}
      </Layout>
    </Provider>
  )
}

const Wrapper = ({ element }) => {
  return <BaseApp element={element} />
}

export const wrapRootElement = Wrapper
